import { ButtonType, ButtonSize } from '@shared/ui/buttons';
import { InputDisplay, InputFieldType } from '@shared/ui/inputs';
import { TableDataColumnFilterType, TableDataColumnOrder } from '@shared/ui/tables';
import { UserRole } from '@shared/utils/base-auth';
import { BadgeType, EvidenceStatus, EvidenceType } from '@shared/utils/evidence-management';
import { IconType } from '@shared/utils/icons';
import { PatternTypes, Patterns } from '@shared/utils/patterns';
import { DeviceTypes } from '@shared/utils/device';

export abstract class StaticPropsComponentExtensions {
  buttonType = ButtonType;
  iconType = IconType;
  buttonSize = ButtonSize;
  tableDataColumnOrder = TableDataColumnOrder;
  tableDataColumnFilterType = TableDataColumnFilterType;
  inputDisplay = InputDisplay;
  inputFieldType = InputFieldType;
  badgeType = BadgeType;
  pattern = Patterns;
  patternType = PatternTypes;

  userRole = UserRole;

  evidenceStatus = EvidenceStatus;
  evidenceType = EvidenceType;

  deviceTypes = DeviceTypes;
}
